import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=faa67114&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=faa67114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa67114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faa67114')) {
      api.createRecord('faa67114', component.options)
    } else {
      api.reload('faa67114', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=faa67114&scoped=true&", function () {
      api.rerender('faa67114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25ItO00WqRiv2/JS/comp/PopupBox.vue"
export default component.exports